import { RoleName } from "../models/User";
import { Department, DepartmentCodes } from "../models/Department";

const adminRoles = [RoleName.Admin];
const approverRoles = [...adminRoles, RoleName.Approver];
const userManagementRoles = [RoleName.Admin, RoleName.UserAdmin, RoleName.DepartmentAdmin];
const departmentWorkflowRoles = [RoleName.Admin, RoleName.DepartmentAdmin];
const invoiceAccessRoles = [...approverRoles, RoleName.InvoiceEntry, RoleName.Spender];
const softwareProjectRoles = [...approverRoles, RoleName.SoftwareManager];
const contentManagerRoles = [...approverRoles, RoleName.ContentManager];

interface AppMenuConfig {
	id: string;
	title: string;
	label: string;
}

export interface AppRouteConfig {
	path: string;
	menu?: AppMenuConfig;
	roles: string[];
	departmentCodes?: string[];
}

export const canAccessDepartment = (route: AppRouteConfig, activeDepartment?: Department): boolean =>
	!route.departmentCodes?.length
	|| Boolean(activeDepartment && route.departmentCodes.some(code => code.toLowerCase() === activeDepartment.code.toLowerCase()));

export const appRouteConfigs: AppRouteConfig[] = [
	{ path: '/', roles: [] },
	{ path: '/admin/users', menu: { id: 'admin', title: 'Admin', label: 'Users' }, roles: userManagementRoles },
	{ path: '/admin/departments', menu: { id: 'admin', title: 'Admin', label: 'Departments' }, roles: adminRoles },
	{ path: '/admin/department-payment-type-workflows', menu: { id: 'admin', title: 'Admin', label: 'Department Workflows' }, roles: departmentWorkflowRoles },
	{ path: '/accounts', menu: { id: 'reference', title: 'Reference Data', label: 'Accounts' }, roles: contentManagerRoles, },
	{ path: '/categories', menu: { id: 'reference', title: 'Reference Data', label: 'Categories' }, roles: contentManagerRoles, },
	{ path: '/customers', menu: { id: 'reference', title: 'Reference Data', label: 'Customers' }, roles: contentManagerRoles },
	{ path: '/locations', menu: { id: 'reference', title: 'Reference Data', label: 'Locations' }, roles: contentManagerRoles },
	{ path: '/splits', menu: { id: 'reference', title: 'Reference Data', label: 'Splits' }, roles: contentManagerRoles },
	{ path: '/vendors', menu: { id: 'reference', title: 'Reference Data', label: 'Vendors' }, roles: contentManagerRoles },
	{ path: '/paymenttypes', menu: { id: 'reference', title: 'Reference Data', label: 'Netsuite Payment Types' }, roles: contentManagerRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/paytypes', menu: { id: 'reference', title: 'Reference Data', label: 'Pay Types' }, roles: contentManagerRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/epictypes', menu: { id: 'reference', title: 'Reference Data', label: 'Epic Types' }, roles: contentManagerRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/hourly/view', menu: { id: 'hourly', title: 'Hourly Charges', label: 'View' }, roles: softwareProjectRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/invoices/view', menu: { id: 'invoices', title: 'Invoices', label: 'Vendor Invoices' }, roles: invoiceAccessRoles },
	{ path: '/invoices/view/:invoiceId', roles: invoiceAccessRoles },
	{ path: '/invoices/invoiceimport', menu: { id: 'invoices', title: 'Invoices', label: 'Import Vendor Invoices' }, roles: invoiceAccessRoles },
	{ path: '/invoices/projectinvoices', menu: { id: 'invoices', title: 'Invoices', label: 'Project Invoices' }, roles: softwareProjectRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/invoices/projectpayments', roles: softwareProjectRoles, departmentCodes: [DepartmentCodes.Prologue] },
	{ path: '/invoices/exportlogs', menu: { id: 'invoices', title: 'Invoices', label: 'ExportLogs' }, roles: approverRoles },
	{ path: '/logout', roles: [] },
];
